import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import AttributeCommand from "@ckeditor/ckeditor5-basic-styles/src/attributecommand";
import { CkeditorConstants } from "../../src/utils/ckeditorconstants";

export const SMALLCAPS = "smallcaps";
const {
  htmlElement: { SPAN },
  PLUGINS: { TRACKCHANGE_EDITING },
} = CkeditorConstants;
export default class SmallcapsEditing extends Plugin {
  init() {
    const editor = this.editor;

    editor.model.schema.extend("$text", { allowAttributes: SMALLCAPS });

    editor.model.schema.setAttributeProperties(SMALLCAPS, {
      isFormatting: true,
      copyOnEnter: true,
    });

    const formattingAttrs = [SMALLCAPS];
    editor.model.schema.addAttributeCheck((context, attributeName) => {
      if (formattingAttrs.includes(attributeName) && context.endsWith(SPAN)) {
        return false;
      }
    });

    editor.conversion.for("downcast").attributeToElement({
      model: SMALLCAPS,

      view: {
        name: SPAN,

        styles: {
          "font-variant": "all-small-caps",
        },
      },

      converterPriority: "high",
    });

    editor.conversion.for("upcast").elementToAttribute({
      view: {
        name: SPAN,

        styles: {
          "font-variant": "all-small-caps",
        },
      },

      model: {
        key: SMALLCAPS,
      },

      converterPriority: "high",
    });

    // Create smallcaps command.
    editor.commands.add(SMALLCAPS, new AttributeCommand(editor, SMALLCAPS));

    const trackChangesEditing = editor.plugins.get(TRACKCHANGE_EDITING);

    trackChangesEditing.descriptionFactory.registerDescriptionCallback(
      (suggestion) => {
        const { data } = suggestion;

        if (!data || data.commandName !== SMALLCAPS) {
          return;
        }

        const content = `*Format:* Smallcaps`;
        return {
          type: "format",
          content,
        };
      }
    );

    trackChangesEditing.enableCommand(SMALLCAPS, (executeCommand) => {
      const selection = editor.model.document.selection;
      const formattedRange = selection.getFirstRange();
      const [targetElement] = formattedRange.getItems();
      if (targetElement) {
        trackChangesEditing.markInlineFormat(formattedRange, {
          commandName: SMALLCAPS,
          commandParams: [{ smallcaps: true }],
        });
      } else {
        executeCommand();
      }
    });
  }
}
